// Most common country codes among our clientele — Gulf, Europe, then global hubs
export const dialCodes = [
  { country: 'United Arab Emirates', iso: 'AE', code: '+971' },
  { country: 'Saudi Arabia', iso: 'SA', code: '+966' },
  { country: 'Qatar', iso: 'QA', code: '+974' },
  { country: 'Kuwait', iso: 'KW', code: '+965' },
  { country: 'Bahrain', iso: 'BH', code: '+973' },
  { country: 'United Kingdom', iso: 'GB', code: '+44' },
  { country: 'Switzerland', iso: 'CH', code: '+41' },
  { country: 'Monaco', iso: 'MC', code: '+377' },
  { country: 'France', iso: 'FR', code: '+33' },
  { country: 'Germany', iso: 'DE', code: '+49' },
  { country: 'Italy', iso: 'IT', code: '+39' },
  { country: 'Spain', iso: 'ES', code: '+34' },
  { country: 'Poland', iso: 'PL', code: '+48' },
  { country: 'Netherlands', iso: 'NL', code: '+31' },
  { country: 'Austria', iso: 'AT', code: '+43' },
  { country: 'Luxembourg', iso: 'LU', code: '+352' },
  { country: 'United States / Canada', iso: 'US', code: '+1' },
  { country: 'Russia', iso: 'RU', code: '+7' },
  { country: 'Singapore', iso: 'SG', code: '+65' },
  { country: 'Hong Kong', iso: 'HK', code: '+852' },
  { country: 'China', iso: 'CN', code: '+86' },
  { country: 'India', iso: 'IN', code: '+91' },
];

// Time zone → country code, used instantly before the network lookup answers
export const timezoneDialCodes: Record<string, string> = {
  'Asia/Dubai': '+971',
  'Asia/Muscat': '+968',
  'Asia/Riyadh': '+966',
  'Asia/Qatar': '+974',
  'Asia/Kuwait': '+965',
  'Asia/Bahrain': '+973',
  'Europe/London': '+44',
  'Europe/Zurich': '+41',
  'Europe/Monaco': '+377',
  'Europe/Paris': '+33',
  'Europe/Berlin': '+49',
  'Europe/Rome': '+39',
  'Europe/Madrid': '+34',
  'Atlantic/Canary': '+34',
  'Europe/Warsaw': '+48',
  'Europe/Amsterdam': '+31',
  'Europe/Vienna': '+43',
  'Europe/Luxembourg': '+352',
  'Europe/Brussels': '+32',
  'Europe/Lisbon': '+351',
  'Europe/Athens': '+30',
  'Europe/Istanbul': '+90',
  'Europe/Moscow': '+7',
  'Asia/Singapore': '+65',
  'Asia/Hong_Kong': '+852',
  'Asia/Shanghai': '+86',
  'Asia/Kolkata': '+91',
  'Asia/Tokyo': '+81',
  'Australia/Sydney': '+61',
};

export const fallbackDialCode = '+971';
